document.addEventListener("DOMContentLoaded", () => {
  const totalEl = document.getElementById("nfi-total-price-value");
  if (!totalEl) return;

  const breakdownEl = document.getElementById("nfi-total-price-breakdown");

  //================================================================================
  // Formatting / helpers
  //================================================================================

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        const fmt = window.Shopify.money_format || "${{amount}}";
        return window.Shopify.formatMoney(Number(cents || 0), fmt);
      }
    } catch (_) {}

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function setTotal(cents, parts) {
    totalEl.textContent = formatMoney(cents);

    if (!breakdownEl) return;

    if (!parts || parts.length === 0) {
      breakdownEl.style.display = "none";
      breakdownEl.textContent = "";
      return;
    }

    breakdownEl.style.display = "block";
    breakdownEl.innerHTML = parts.map(x => `<div>${x}</div>`).join("");
  }

  function getQuantity() {
    const el =
      document.querySelector("quantity-selector input[name='quantity']") ||
      document.querySelector("input[name='quantity']");

    const q = Number(el?.value);
    return Number.isFinite(q) && q > 0 ? q : 1;
  }



  //================================================================================
  // Context API (single source of truth)
  //================================================================================

  function getCtx() {
    // Prefer the shared context from custom.product-info.js
    if (window.NFFI_Product && typeof window.NFFI_Product.getContext === "function") {
      return window.NFFI_Product.getContext();
    }

    return null;
  }

  //================================================================================
  // Modes (should mirror custom.product-info.js)
  //================================================================================

  const PRODUCT_MODES = {
    NONE: "NONE",
    LEGACY_BUNDLE_BAG_HLST: "LEGACY_BUNDLE_BAG_HLST",
    LEGACY_BAG_WITH_HOLSTER: "LEGACY_BAG_WITH_HOLSTER",
    LEGACY_BAG_WITH_ADAPTER: "LEGACY_BAG_WITH_ADAPTER",
    LEGACY_SIMPLE_BAG: "LEGACY_SIMPLE_BAG",
    STANDALONE_HOLSTER: "STANDALONE_HOLSTER",
    CHEST_HOLSTER: "CHEST_HOLSTER",
    BAG_OPTIONS_BAG_ONLY: "BAG_OPTIONS_BAG_ONLY",
    BAG_OPTIONS_BAG_WITH_HOLSTER: "BAG_OPTIONS_BAG_WITH_HOLSTER",
    BAG_OPTIONS_BAG_WITH_ADAPTER: "BAG_OPTIONS_BAG_WITH_ADAPTER"
  };

  function getBagConfig() {
    const checked = document.querySelector("input[name='bag-config-ui']:checked");
    return checked ? checked.value : null;
  }

  function getProductMode(ctx) {
    if (!ctx) return PRODUCT_MODES.NONE;

    const {
      isBag,
      isHolster,
      isChestHolster,
      isLegacyBagWithHolster,
      isLegacyBagWithAdapter,
      isBundleBagHlstSingle,
      bagOptionsEnabled
    } = ctx;

    if (isBundleBagHlstSingle && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_BUNDLE_BAG_HLST;
    }

    if (isLegacyBagWithHolster && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_BAG_WITH_HOLSTER;
    }

    if (isLegacyBagWithAdapter && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_BAG_WITH_ADAPTER;
    }

    if (isChestHolster && !isBag) {
      return PRODUCT_MODES.CHEST_HOLSTER;
    }

    if (isHolster && !isBag) {
      return PRODUCT_MODES.STANDALONE_HOLSTER;
    }

    if (isBag && bagOptionsEnabled) {
      // IMPORTANT: no default "BAG_ONLY" here; cfg is only what user selected
      const cfg = getBagConfig();

      if (cfg === "BAG_WITH_HOLSTER") return PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER;
      if (cfg === "BAG_WITH_ADAPTER") return PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_ADAPTER;
      return PRODUCT_MODES.BAG_OPTIONS_BAG_ONLY;
    }

    if (isBag && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_SIMPLE_BAG;
    }

    return PRODUCT_MODES.NONE;
  }

  //================================================================================
  // AutoProducts / Addons
  //================================================================================

  function getAutoProductsMeta(ctx) {
    const ap = ctx?.addons?.AutoProducts;
    if (!Array.isArray(ap) || ap.length === 0) return [];

    return ap.reduce((acc, p) => {
      const v = Array.isArray(p.variants) ? p.variants[0] : null;
      if (!v || v.available === false) return acc;

      const cents = Number(v.price);
      if (!Number.isFinite(cents)) return acc;

      acc.push({
        title: p.title || "Add-on",
        price: cents
      });

      return acc;
    }, []);
  }

  function getSelectedAddonBlocksMeta() {
    const selected = document.querySelectorAll(".addon-block.selected");
    const result = [];

    selected.forEach(el => {
      const cents = Number(el.getAttribute("data-addon-price-cents"));
      if (!Number.isFinite(cents)) return;

      const title =
        el.getAttribute("data-addon-title") ||
        el.querySelector(".addon-block__title")?.textContent.trim() ||
        "Add-on";

      result.push({ title, price: cents });
    });

    return result;
  }

  //================================================================================
  // Core: recalcTotal – must mirror getProductItems()
  //================================================================================

  function recalcTotal() {    
    const ctx = getCtx();
    console.log("[NFFI] recalcTotal context:", ctx);
    if (!ctx || !ctx.product) return;

    const mode = getProductMode(ctx);

    const {
      product,
      variant,
      bagMetaVariant,
      adapterMetaVariant,
      addons,
      isBag,
      isHolster,
      isChestHolster,
      isBundleBagHlstSingle,
      isLegacyBagWithHolster,
      isLegacyBagWithAdapter,
      hasAutoProducts
    } = ctx;

    const qty = getQuantity();
    const parts = [];
    let totalPerUnit = 0;

    // If Bag Options UI exists and user hasn't chosen a mode -> Total must be 0
    const bagConfigRadios = document.querySelectorAll("input[name='bag-config-ui']");
    const cfgRaw = getBagConfig();

    if (
      ctx.isBag &&
      ctx.bagOptionsEnabled &&
      !ctx.isBundleBagHlstSingle &&
      !ctx.isLegacyBagWithHolster &&
      !ctx.isLegacyBagWithAdapter &&
      bagConfigRadios.length > 0 &&
      !cfgRaw
    ) {
      setTotal(0, []);
      return;
    }

    // Main line: BAG metafield wins if allowed
    const mainVariant = ctx.canUseBagMetaAsMain && bagMetaVariant ? bagMetaVariant : variant;

    const mainPriceCents = Number(mainVariant?.price) || 0;

    let mainTitle = product?.title || "";
    if (ctx.canUseBagMetaAsMain && addons?.BAG?.title) {
      mainTitle = addons.BAG.title;
    }

    // LEGACY_BUNDLE_BAG_HLST: one bundle line + autoproducts + addons
    if (mode === PRODUCT_MODES.LEGACY_BUNDLE_BAG_HLST) {
      totalPerUnit += mainPriceCents;
      if (mainTitle) parts.push(`${mainTitle}: ${formatMoney(mainPriceCents)}`);

      // AutoProducts
      getAutoProductsMeta(ctx).forEach(ap => {
        totalPerUnit += ap.price;
        parts.push(`${ap.title}: ${formatMoney(ap.price)}`);
      });

      // addon blocks
      getSelectedAddonBlocksMeta().forEach(addon => {
        totalPerUnit += addon.price;
        parts.push(`${addon.title}: ${formatMoney(addon.price)}`);
      });

      const total = totalPerUnit * qty;
      parts.push(`Qty: ${qty}`);
      setTotal(total, parts);
      return;
    }

    // LEGACY_BAG_WITH_ADAPTER: single combined product line
    if (mode === PRODUCT_MODES.LEGACY_BAG_WITH_ADAPTER) {
      totalPerUnit += mainPriceCents;
      if (mainTitle) parts.push(`${mainTitle}: ${formatMoney(mainPriceCents)}`);

      // AutoProducts
      getAutoProductsMeta(ctx).forEach(ap => {
        totalPerUnit += ap.price;
        parts.push(`${ap.title}: ${formatMoney(ap.price)}`);
      });

      // addon blocks
      getSelectedAddonBlocksMeta().forEach(addon => {
        totalPerUnit += addon.price;
        parts.push(`${addon.title}: ${formatMoney(addon.price)}`);
      });

      const total = totalPerUnit * qty;
      parts.push(`Qty: ${qty}`);
      setTotal(total, parts);
      return;
    }

    // Base line for all other modes
    totalPerUnit += mainPriceCents;
    if (mainTitle) parts.push(`${mainTitle}: ${formatMoney(mainPriceCents)}`);

    // BAG_WITH_ADAPTER (Bag Options split)
    if (mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_ADAPTER) {
      let adapterPrice = 0;
      let adapterTitle = addons?.["IWB Adapter"]?.title || "";

      const adapterPriceInput = document.querySelector("#selected-adapter-price-cents");
      if (adapterPriceInput) {
        const n = Number(adapterPriceInput.value);
        if (Number.isFinite(n) && n > 0) adapterPrice = n;
      }

      if (!adapterPrice && adapterMetaVariant) {
        const n = Number(adapterMetaVariant.price);
        if (Number.isFinite(n)) adapterPrice = n;
      }

      if (adapterPrice > 0) {
        totalPerUnit += adapterPrice;
        if (adapterTitle) parts.push(`${adapterTitle}: ${formatMoney(adapterPrice)}`);
      }
    }

    // CHEST_HOLSTER
    if (
      mode === PRODUCT_MODES.CHEST_HOLSTER
    ) {
      const holsterPriceEl = document.querySelector("#selected-holster-price-cents");
      let holsterPrice = 0;

      if (holsterPriceEl) {
        const n = Number(holsterPriceEl.value);
        if (Number.isFinite(n) && n > 0) holsterPrice = n;
      }

      if (holsterPrice > 0) {
        const holsterTitle =
          document.querySelector("#selected-holster-name")?.value || "";

        totalPerUnit += holsterPrice;
        if (holsterTitle) parts.push(`${holsterTitle}: ${formatMoney(holsterPrice)}`);
      }
    }

    // BAG_WITH_HOLSTER (legacy + Bag Options)
    if (
      mode === PRODUCT_MODES.LEGACY_BAG_WITH_HOLSTER ||
      mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER
    ) {
      const holsterPriceEl = document.querySelector("#selected-holster-price-cents");
      let holsterPrice = 0;

      if (holsterPriceEl) {
        const n = Number(holsterPriceEl.value);
        if (Number.isFinite(n) && n > 0) holsterPrice = n;
      }

      if (holsterPrice > 0) {
        const holsterTitle =
          document.querySelector("#selected-holster-name")?.value || "";

        totalPerUnit += holsterPrice;
        if (holsterTitle) parts.push(`${holsterTitle}: ${formatMoney(holsterPrice)}`);
      }
    }

    // AutoProducts
    getAutoProductsMeta(ctx).forEach(ap => {
      totalPerUnit += ap.price;
      parts.push(`${ap.title}: ${formatMoney(ap.price)}`);
    });

    // addon blocks
    getSelectedAddonBlocksMeta().forEach(addon => {
      totalPerUnit += addon.price;
      parts.push(`${addon.title}: ${formatMoney(addon.price)}`);
    });

    const total = totalPerUnit * qty;
    parts.push(`Qty: ${qty}`);
    setTotal(total, parts);
  }

  //================================================================================
  // Events / bindings
  //================================================================================

  const qtyInput =
    document.querySelector("quantity-selector input[name='quantity']") ||
    document.querySelector("input[name='quantity']");

  if (qtyInput) {
    qtyInput.addEventListener("input", recalcTotal);
    qtyInput.addEventListener("change", recalcTotal);
  }

  document
    .querySelectorAll("quantity-selector .quantity-selector__button")
    .forEach(btn => {
      btn.addEventListener("click", () => setTimeout(recalcTotal, 0));
    });

  document.addEventListener("variant:change", recalcTotal);

  document.addEventListener("shopify:section:load", recalcTotal);

  const idInput = document.querySelector('form[action$="/cart/add"] [name="id"]');
  if (idInput) {
    idInput.addEventListener("change", recalcTotal);
  }

  // External triggers (from firearm-options.js / bag-options.js)
  document.addEventListener("nffi:product:changed", recalcTotal);
  document.addEventListener("nffi:bag-options:changed", recalcTotal);
  document.addEventListener("nffi:holster-selected", recalcTotal);
  document.addEventListener("nffi:adapter-selected", recalcTotal);
  document.addEventListener("nffi:total:recalc", recalcTotal);

  // Initial
  recalcTotal();

  // Expose minimal API
  window.NFFI_TotalPrice = {
    recalc: recalcTotal
  };
});
